{
  "concept": [
    "E4",
    "L3",
    "P1"
  ],
  "note": "Was ein Freund nach einem Auftrag erzählt (woodToo: Holz, wenn schon ein Item dabei war; Fabi, Phase Kern: nach einem Item darf nicht „so viel Holz“ stehen), in der Stimme seiner Spezies (Fabi: mündlich, kein Brief; einen Zettel gibt es nur, wenn jemand fernbleibt). Texte von Claude, überarbeitet von Fabi (13.10.2026). Keine abgehackten Kurz- oder Einwortsätze. {beute} ist das Item, {tier} der neue Freund mit Spezies, {tiername} nur sein Name.",
  "placeholder": true,
  "voices": {
    "dachs": {
      "hello": [
        "Bin wieder da und hab' ein ganz schönes Abenteuer erlebt. Ich erzähle später mehr.",
        "Da bin ich wieder. Der Boden da drüben ist gut zum Graben, nur so nebenbei."
      ],
      "bye": [
        "Jetzt mache ich mir erstmal einen warmen Kakao.",
        "Ich leg mich jetzt erstmal hin, das war ziemlich anstrengend."
      ]
    },
    "igel": {
      "hello": [
        "Zurück. Unterwegs hab ich mich zweimal eingerollt, nur zur Sicherheit.",
        "Da bin ich wieder, ganz leise, wie immer."
      ],
      "bye": [
        "Jetzt muss ich erstmal meine Stacheln richten.",
        "Jetzt kuschel ich mich erstmal in einen Haufen Laub, da schläft es sich am besten."
      ]
    },
    "eichhoernchen": {
      "hello": [
        "Da bin ich wieder!! Ich bin über SO viele Äste gesprungen! Und bin auf ganz viele Bäume geklettert! Und habe … ach, erzähle ich später.",
        "Zurück! Ich hab unterwegs nur ganz kurz Nüsse versteckt. Nur für den Fall, dass man doch nochmal vorbeikommt!"
      ],
      "bye": [
        "Möchte jemand mit mir Fangen spielen?",
        "Wann geht's wieder los?"
      ]
    },
    "eisvogel": {
      "hello": [
        "Zurück vom Flug! Das Wasser war klar, und von oben konnte ich bis weit flussabwärts sehen.",
        "Da bin ich wieder. Ich habe alles gesehen, was es da drüben zu sehen gab, und noch ein bisschen mehr."
      ],
      "bye": [
        "Jetzt putze ich erstmal in Ruhe meine Federn.",
        "Ich setze mich ein bisschen auf die Reling und schaue aufs Wasser."
      ]
    },
    "wasserspitzmaus": {
      "hello": [
        "Bin zurück! Unterwegs hab ich drei Käfer gegessen, na gut, eher vier.",
        "Zack, wieder da! Gibt es hier eigentlich schon was zu essen?"
      ],
      "bye": [
        "Ich werde mir jetzt erstmal eine Mahlzeit fangen.",
        "Ist noch was von gestern übrig?"
      ]
    },
    "waschbaer": {
      "hello": [
        "Wieder an Bord. Ich habe mir unterwegs gründlich die Pfoten gewaschen, versteht sich.",
        "Zurück. Alles erledigt, und nichts davon war schmutzig."
      ],
      "bye": [
        "Alles sauber und ordentlich, so wie es sein soll.",
        "Ich wasche das hier nur noch kurz ab, dann bin ich ganz bei euch."
      ]
    },
    "elster": {
      "hello": [
        "Da bin ich wieder! Ratet mal, wie viel Glänzendes ich unterwegs gesehen habe.",
        "Zurück! Ich hätte fast etwas mitgenommen, aber es gehörte jemandem, ehrlich."
      ],
      "bye": [
        "Jetzt muss ich erst einmal mein Gefieder putzen, das ist ganz zerzaust.",
        "Ich setze mich jetzt in mein Nest und zähle in Ruhe meine Schätze."
      ]
    },
    "feuersalamander": {
      "hello": [
        "Da bin ich wieder, langsam, aber sicher.",
        "Zurück! Unterwegs hat es geregnet, und das war einfach herrlich."
      ],
      "bye": [
        "Jetzt suche ich mir einen schattigen, feuchten Platz zum Ausruhen.",
        "Meine Kratzer verheilen zum Glück schnell, morgen sieht man nichts mehr davon."
      ]
    },
    "biber": {
      "hello": [
        "Bin wieder da. Unterwegs habe ich gleich noch einen Steg geflickt.",
        "Da bin ich. Das Holz da drüben war übrigens erstklassig."
      ],
      "bye": [
        "Jetzt nage ich mir erstmal einen Ast zum Abendbrot.",
        "Ich schau gleich nach, ob am Floß alles hält."
      ]
    },
    "fuchs": {
      "hello": [
        "Da bin ich wieder, und ich habe natürlich den besten Weg gefunden.",
        "Zurück! Ihr hättet sehen sollen, wie ich mich da herausgeredet habe."
      ],
      "bye": [
        "Jetzt rolle ich mich erstmal in meinen Schwanz und mache ein Nickerchen.",
        "Weckt mich, wenn es etwas zu handeln gibt."
      ]
    },
    "otter": {
      "hello": [
        "Juhu, ich bin wieder da! Das Wasser da drüben war herrlich.",
        "Da bin ich! Ich hab unterwegs einen ganz flachen Stein gefunden."
      ],
      "bye": [
        "Jetzt lege ich mich auf den Rücken und lasse mich ein bisschen treiben.",
        "Wer kommt mit, Steine flitschen?"
      ]
    }
  },
  "lines": {
    "levelUp": [
      "Unterwegs hab ich viel gelernt. Ich glaube, ich bin stärker geworden.",
      "Ich fühle mich größer, nicht wirklich größer, aber stärker."
    ],
    "item": [
      "Ich hab euch etwas mitgebracht: {beute}.",
      "Schaut mal, was ich gefunden habe: {beute}!",
      "Schaut mal: {beute}! Das lag einfach so rum, wirklich! Wer lässt so einen wertvollen Gegenstand liegen?"
    ],
    "wood": [
      "Holz für den Händler hab ich auch mitgebracht.",
      "Unterwegs lag Holz herum, das hab ich gleich eingesammelt.",
      "Das Holz hier lag einfach so rum, wirklich! Wer lässt so viel Holz liegen?"
    ],
    "woodToo": [
      "Und Holz für den Händler hab ich auch dabei.",
      "Ein paar Stücke Holz waren auch noch übrig, die hab ich gleich mitgenommen."
    ],
    "recruit": [
      "Und ich bin nicht allein zurück: {tier} möchte mit uns reisen.",
      "Guckt mal, wen ich unterwegs getroffen habe! {tiername} und ich haben uns angefreundet. Können wir {tiername} mitnehmen, bitte?",
      "Unterwegs hab ich jemanden getroffen: {tier}. Darf {tiername} mit?"
    ],
    "injure": [
      "Ganz heil bin ich nicht geblieben, aber es geht schon.",
      "Es gab einen kleinen Zwischenfall. Ich erzähl's später."
    ],
    "nothing": [
      "Gefunden hab ich nichts, aber die Aussicht war schön.",
      "Die Umgebung war schön, aber ein bisschen langweilig ist mir schon geworden. Bin froh, wieder hier zu sein!"
    ]
  },
  "farewell": {
    "title": "Ein Zettel am Ufer",
    "lines": [
      "Ich hab unterwegs einen Ort gefunden, an dem ich bleiben möchte. Seid nicht traurig. Fahrt vorsichtig.",
      "Ich komme nicht zurück aufs Floß. Hier gibt es ein Zuhause für mich. Danke für alles."
    ]
  }
}
